@app.directive 'csFooter', ->
  restrict: 'E'
  templateUrl: "/assets/templates/directives/footer/footer.html"
